import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import useTabId from '../../../utils/useTabId';
import AiAssistantChatbotStore from '../store/AiAssistantChatbotStore';
import {AiAssitantChatMessage} from '../../../data/models/AI/AiAssistantModels';

export function usePageChatbot(store: AiAssistantChatbotStore | undefined) {
  const [chat, setChat] = useState<AiAssitantChatMessage[]>([]);
  const [title, setTitle] = useState('');
  const tabId = useTabId();
  const {organizationId: orgIdFromRoute} = useParams();
  const orgId = orgIdFromRoute ?? '';

  useEffect(() => {
    if (store?.currentAssistant) {
      store
        .getAssistantPublicChat(orgId, store.currentAssistant, tabId)
        .then(res => {
          if (res) setChat(res.chat_history);
        });

      const params = new URLSearchParams(window.location.search);
      store.setColorsFromQueryString(
        params.get('primary') ?? '',
        params.get('secondary') ?? '',
      );
      setTitle(params.get('title') ?? '');
    }
  }, [store?.currentAssistant]);

  const sendMessage = async (message: string) => {
    if (!store || !orgId) return;
    const oldChat = [...chat];
    setChat([
      ...chat,
      {learner_question: message, assistant_response: '', created_on: ''},
    ]);
    const res = await store.sendMessage(orgId, tabId, message, true);
    setChat(res?.chat_history ?? oldChat);
  };

  const clearChat = async () => {
    if (store) {
      const success = await store.clearAssistantChat(tabId);
      if (success && store.currentAssistant) {
        const res = await store.getAssistantPublicChat(
          orgId,
          store.currentAssistant,
          tabId,
        );
        if (res) setChat(res.chat_history);
      }
    }
  };

  return {
    chat,
    title,
    sendMessage,
    clearChat,
    tabId,
    assistantAvatar: undefined,
  };
}
